import React from "react";
import { Modal, Spinner } from "reactstrap";
import { connect } from "react-redux";
class Loader extends React.Component {
  render() {
    const { isLoading } = this.props.loaderDetails;
    if (isLoading) {
      return (
        <Modal isOpen={true} className="modal-dialog-centered loader-modal">
          <Spinner color="dark" className="centered" />
        </Modal>
      );
    }
    return <></>;
  }
}

const mapStateToProps = (state) => ({
  loaderDetails: state.loaderDetails
});

export default connect(mapStateToProps, null)(Loader);
